<template>
    <div class="content mt-4 mb-4">
        <div class="secoes mb-5">
            <div class="titulo-secoes mb-5">
                <h4 class="text-uppercase">Parceiros</h4>
            </div>
            <div class="mt-5 hidden-sm-down" style="width: 100%">
                <div>
                    <div class="flex-grid">
                        <div class="flex-xs-6 flex-sm-6 flex-md-6">
                            <ul
                                class="d-flex flex-wrap flex-spaced-fixed table-fluid-sustentabilidade"
                                style="gap: 1rem"
                            >
                                <li
                                    v-for="partner in partners"
                                    :key="partner.symbols"
                                    :class="[
                                        partner.classObject,
                                        partner.classObject.active ? 'text-underline' : '',
                                        partner.classObject.classPosition,
                                    ]"
                                    class="partners-icons text-uppercase text-center text-bold"
                                    @click="getPartner(partner, true)"
                                    @mouseover="getPartner(partner, true)"
                                >
                                    {{ partner.symbols }}
                                </li>
                            </ul>
                            <div
                                class="text-center mt-4 d-flex flex-justify-center flex-wrap flex-spaced-fixed"
                            >
                                <p class="mr meio-ambiente-text">Meio Ambiente</p>
                                <p class="mr ml pessoas-text">Pessoas</p>
                                <p class="mr ml cultura-text">Cultura</p>
                            </div>
                        </div>
                        <div class="flex-xs-6 flex-sm-6 flex-md-6 pl-5">
                            <div v-show="partnerInfos" class="overflow-hidden">
                                <div :class="slideMove">
                                    <h2 class="text-bold">{{ partnerInfos.title }}</h2>
                                    <p>
                                        {{ partnerInfos.description }}
                                    </p>

                                    <a
                                        class="text-default-5 text-bold text-underline"
                                        :href="partnerInfos.link"
                                        v-if="partnerInfos.link"
                                        target="_blank"
                                        >{{ partnerInfos.textLink }}</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="hidden-sm-up mt-2 collapside-partners-sustainability">
                <h6 class="text-uppercase text-bold pessoas-text mb-4">Pessoas</h6>

                <div
                    v-for="partner in partners.filter((item) => {
                        return item.objClass.indexOf('pessoas') > -1;
                    })"
                >
                    <button
                        class="collapsible-button h5 text-bold pessoas-button-collapside text-uppercase text-left"
                        type="button"
                    >
                        <i class="icon-cr icon-chevron-down-2 collapsible-icon mr-3"></i>
                        {{ partner.content.title }}
                    </button>
                    <div class="collapsible-text text-light pessoas">
                        <p>{{ partner.content.description }}</p>
                        <p>
                            <a
                                class="text-underline"
                                :href="partner.content.link"
                                v-if="partner.content.link"
                                target="_blank"
                                >{{ partner.content.textLink }}</a
                            >
                        </p>
                    </div>
                </div>

                <h6 class="text-uppercase text-bold meio-ambiente-text mt-5 mb-4">Meio Ambiente</h6>
                <div
                    v-for="partner in partners.filter((item) => {
                        return item.objClass.indexOf('meio-ambiente') > -1;
                    })"
                >
                    <button
                        class="collapsible-button h5 text-bold meio-ambiente-button-collapside text-uppercase text-left"
                        type="button"
                    >
                        <i class="icon-cr icon-chevron-down-2 collapsible-icon mr-3"></i>
                        {{ partner.content.title }}
                    </button>
                    <div class="collapsible-text text-light meio-ambiente">
                        <p>{{ partner.content.description }}</p>
                        <p>
                            <a
                                class="text-underline"
                                :href="partner.content.link"
                                v-if="partner.content.link"
                                target="_blank"
                                >{{ partner.content.textLink }}</a
                            >
                        </p>
                    </div>
                </div>

                <h6 class="text-uppercase text-bold cultura-text mt-5 mb-4">Cultura</h6>
                <div
                    v-for="partner in partners.filter((item) => {
                        return item.objClass.indexOf('cultura') > -1;
                    })"
                >
                    <button
                        class="collapsible-button h5 text-bold cultura-button-collapside text-uppercase text-left"
                        type="button"
                    >
                        <i class="icon-cr icon-chevron-down-2 collapsible-icon mr-3"></i>
                        {{ partner.content.title }}
                    </button>
                    <div class="collapsible-text text-light cultura">
                        <p>{{ partner.content.description }}</p>
                        <p>
                            <a
                                class="text-underline"
                                :href="partner.content.link"
                                v-if="partner.content.link"
                                target="_blank"
                                >{{ partner.content.textLink }}</a
                            >
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PartnersSustainability',

        data() {
            return {
                slideMove: 'slide-in',
                pauseAnimation: false,
                partners: [
                    // {
                    //     symbols: 'cas',
                    //     classObject: { active: false, cultura: true, classPosition: 'cas' },
                    //     objClass: 'cultura',
                    //     content: {
                    //         title: 'Casa do Choro',
                    //         description:
                    //             'A Casa do Choro atua no terreno da educação musical, preservação e divulgação da música popular carioca, em especial o choro. Suas atividades são voltadas para a formação de plateias e de músicos profissionais, produção e difusão de shows e eventos, manutenção e conservação de acervos, catalogação, registro e preservação da memória musical.',
                    //     },
                    // },
                    // {
                    //     symbols: 'afr',
                    //     classObject: { active: false, pessoas: true, classPosition: 'afr' },
                    //     objClass: 'pessoas',
                    //     content: {
                    //         title: 'AfroPython',
                    //         description:
                    //             'Transformar pessoas e impactar vidas através do conhecimento. É isso que o AfroPython faz desde 2017. O movimento existe para aumentar a representatividade de pessoas negras dentro da área de tecnologia, oferecendo oportunidade de ascensão profissional e empoderamento. ',
                    //     },
                    // },
                    {
                        symbols: 'rei',
                        classObject: { active: false, cultura: true, classPosition: 'rei' },
                        objClass: 'cultura',
                        content: {
                            title: 'Associação Amigos do Reinado',
                            description:
                                'A celebração do Reinado de Nossa Senhora do Rosário e Santa Ifigênia é patrimônio imaterial da cidade de Ouro Preto e acontece no início de janeiro, como símbolo de devoção e resistência. A comemoração tem mais de 300 anos de história, mas a tradição estava se perdendo quando, em 2008, pela união de pessoas através da Associação Amigos do Reinado e por grupos locais, o encontro foi retomado.',
                            link: '/amirei',
                            textLink: 'Veja produtos dessa parceria',
                        },
                    },
                    // {
                    //     symbols: 'uça',
                    //     classObject: { active: false, 'meio-ambiente': true, classPosition: 'uca' },
                    //     objClass: 'meio-ambiente',
                    //     content: {
                    //         title: 'Projeto Uça',
                    //         description:
                    //             'O Projeto Uçá é uma iniciativa desenvolvida pela ONG Guardiões do Mar. Recebe esse nome pelo trabalho de monitorar as fases de desenvolvimento do caranguejo-uçá, espécie importante para o meio ambiente e para a economia das regiões dos manguezais brasileiros.',
                    //
                    //     },
                    // },
                    {
                        symbols: 'joc',
                        classObject: { active: false, pessoas: true, classPosition: 'joc' },
                        objClass: 'pessoas',
                        content: {
                            title: 'Instituto Jô Clemente',
                            description:
                                'O Instituto Jô Clemente é uma organização da sociedade civil sem fins lucrativos, referência na prevenção e na melhor qualidade de vida da pessoa com Deficiência Intelectual. Atua em todas as fases da vida, da infância ao processo de envelhecimento.',
                        },
                    },
                    {
                        symbols: 'mat',
                        classObject: { active: false, 'meio-ambiente': true, classPosition: 'mat' },
                        objClass: 'meio-ambiente',
                        content: {
                            title: 'SOS Mata Atlântica',
                            description:
                                'A preservação das nossas matas é um assunto urgente e atual, afinal, é um dos pontos vitais do nosso planeta azul. Por isso, a Chico Rei levantou a bandeira em prol da preservação ambiental em uma coleção representativa e lindíssima para mostrar que você também faz parte desta luta. Confira agora todas as canecas, posters e camisetas SOS Mata Atlântica.',
                            link: '/sos-mata-atlantica',
                            textLink: ' Conheça a coleção',
                        },
                    },
                    {
                        symbols: 'cuf',
                        classObject: { active: false, pessoas: true, classPosition: 'cuf' },
                        objClass: 'pessoas',
                        content: {
                            title: 'CUFA Ceará',
                            description:
                                'A CUFA (Central Única das Favelas) é uma organização brasileira reconhecida nacional e internacionalmente nos âmbitos político, social, esportivo e cultural que existe há 20 anos. ' +
                                'Foi criada a partir da união entre jovens de várias favelas, principalmente negros, que buscavam espaços para expressarem suas atitudes, questionamentos ou simplesmente sua vontade de viver. ' +
                                'A CUFA Ceará tem, neste momento, a missão de conter o avanço da Covid-19 nas favelas. No Ceará, são mais de 200 favelas e mais de 500 voluntários, na capital Fortaleza, em Sobral, Maracanaú e Juazeiro. A ideia é driblar a burocracia e possibilitar o acesso rápido desses grupos vulneráveis a recursos, com foco, eficiência e transparência.' +
                                'A camiseta Solidariedade é uma parceria da Chico Rei com a CUFA Ceará, e todo o lucro dessa campanha será revertido aos projetos da instituição para reduzir os impactos sociais da pandemia.',
                            link: '/camiseta/camiseta-solidariedade-18043.html',
                            textLink: ' Conheça a camiseta solidariedade',
                        },
                    },
                    {
                        symbols: 'ama',
                        classObject: { active: false, 'meio-ambiente': true, classPosition: 'ama' },
                        objClass: 'meio-ambiente',
                        content: {
                            title: 'SOS Amazônia',
                            description:
                                'Um projeto que nasceu para amar e proteger a Floresta Amazônica, fazendo brilhar toda a vida que colore o nosso país! Nós acreditamos que algumas bandeiras precisam ser levantadas por muitas mãos e corações, por isso, nos unimos a essa causa e criamos uma coleção totalmente dedicada à preservação das nossas florestas. Confira as estampas que chegam para compor a coleção oficial SOS Amazônia!',
                            link: '/sos-amazonia',
                            textLink: ' Conheça a coleção',
                        },
                    },
                    // {
                    //     symbols: 'tet',
                    //     classObject: { active: false, pessoas: true, classPosition: 'tet' },
                    //     objClass: 'pessoas',
                    //     content: {
                    //         title: 'TETO Brasil',
                    //         description:
                    //             'A TETO é uma organização nascida a partir do sonho de transformar a realidade dessas pessoas. A iniciativa está presente em 18 países da América Latina e atua há mais de 14 anos no Brasil. Promove a melhoria das condições de moradia e habitat dessas populações e o desenvolvimento econômico e social das comunidades, por meio do trabalho conjunto entre moradores de favelas e jovens voluntários e voluntárias.',
                    //     },
                    // },
                    // {
                    //     symbols: 'asc',
                    //     classObject: { active: false, pessoas: true, classPosition: 'asc'},
                    //     objClass: 'pessoas',
                    //     content: {
                    //         title: 'ASCOMCER',
                    //         description:
                    //             'A Associação Feminina de Prevenção e Combate ao Câncer de Juiz de Fora (ASCOMCER) é uma entidade civil de caráter filantrópico. Em quase 60 anos de existência, todos os seus recursos são voltados aos pacientes, fazendo do combate e da prevenção do câncer uma luta constante.',
                    //     },
                    // },
                    {
                        symbols: 'bru',
                        classObject: { active: false, pessoas: true, classPosition: 'bru' },
                        objClass: 'pessoas',
                        content: {
                            title: 'Instituto Bruno',
                            description:
                                'O Instituto Bruno é uma ONG que há mais de 20 anos realiza um trabalho tido como referencial a pessoas com paralisia cerebral e surdocegueira em Juiz de Fora e região. A instituição defende o protagonismo das pessoas com deficiência na sociedade, atuando na luta por inclusão e aprendizado.',
                            link: '/instituto-bruno',
                            textLink: ' Conheça a coleção',
                        },
                    },
                    {
                        symbols: 'pan',
                        classObject: { active: false, 'meio-ambiente': true, classPosition: 'pan' },
                        objClass: 'meio-ambiente',
                        content: {
                            title: 'SOS Pantanal',
                            description:
                                'O Pantanal é um dos maiores refúgios brasileiros que hoje abriga mais de 4.700 espécies. A maior terra úmida do planeta alimenta a vida ao mesmo tempo que nos ensina sobre ela. Em parceria com o SOS Pantanal, a Chico Rei lançou uma coleção que veste essa causa e luta pela preservação da nossa terra verde com estampas que carregam significado, diversidade e cor.',
                            link: '/sos-pantanal',
                            textLink: ' Conheça a coleção',
                        },
                    },
                    {
                        symbols: 'mmc',
                        classObject: { active: false, cultura: true, classPosition: 'mmc' },
                        objClass: 'cultura',
                        content: {
                            title: 'Meninas e Mulheres na Ciência',
                            description:
                                'O Meninas e Mulheres na Ciência foi criado em março de 2018 com o objetivo de incentivar meninas a se interessarem por Ciência, fomentar o debate sobre a desigualdade de gênero no setor e discutir formas de reverter esse quadro. De forma contínua, promove visitações em escolas com roda de conversa levando profissionais mulheres de diversas áreas. Venha fazer parte desse movimento!',
                            link: '/meninas-e-mulheres-na-ciencia',
                            textLink: ' Conheça a coleção',
                        },
                    },
                    {
                        symbols: 'her',
                        classObject: { active: false, pessoas: true, classPosition: 'her' },
                        objClass: 'pessoas',
                        content: {
                            title: 'Somos Todos Heróis',
                            description:
                                'Somos Todos Heróis é uma ONG que ajuda crianças com necessidades médicas especiais conectando doadores e famílias através de um plataforma exclusiva. Já ajudaram mais de mil crianças, graças a mais de R$ 60 mil arrecadados.',
                        },
                    },
                    {
                        symbols: 'aum',
                        classObject: { active: false, pessoas: true, classPosition: 'aum' },
                        objClass: 'pessoas',
                        content: {
                            title: 'AUMA',
                            description:
                                'A Associação dos Amigos das Crianças Autistas (AUMA), de São Paulo, apoia crianças com autismo e seus familiares há mais de 30 anos. Porque o bonito da primavera precisa de todas as flores.',
                            link: '/auma',
                            textLink: ' Conheça a coleção',
                        },
                    },
                    {
                        symbols: 'izp',
                        classObject: { active: true, pessoas: true, classPosition: 'izp' },
                        objClass: 'pessoas',
                        content: {
                            title: 'Instituto Zeca Pagodinho',
                            description:
                                'A Coleção Oficial do ilustre Zeca Pagodinho tem a renda destinada ao Instituto que leva o seu nome. Com as vendas, já conseguimos repassar mais de R$ 110 mil para os projetos do instituto.',
                            link: '/zeca-pagodinho',
                            textLink: ' Conheça a coleção',
                        },
                    },
                    {
                        symbols: 'all',
                        classObject: { active: false, pessoas: true, classPosition: 'all' },
                        objClass: 'pessoas',
                        content: {
                            title: 'All Out',
                            description:
                                'Qualquer maneira de amor vale a pena e vale amar. É sobre abraçar esse sentimento que floresce de dentro para fora e contagia a todos. No mês do Orgulho LGBT+, a Chico Rei lança uma coleção que transborda esse sentir bonito, que fala de respeito, de igualdade e amor.',
                            link: '/all-out',
                            textLink: ' Conheça a coleção',
                        },
                    },
                    {
                        symbols: 'tra',
                        classObject: { active: false, pessoas: true, classPosition: 'tra' },
                        objClass: 'pessoas',
                        content: {
                            title: 'EducaTRANSforma',
                            description:
                                'O EducaTRANSforma faz um trabalho super importante e necessário de capacitação gratuita e inserção de pessoas transgênero (transexuais, travestis, não-binários e intersexo) no mercado de trabalho de Tecnologia da Informação, buscando ser uma ponte entre esses profissionais e a admissão trabalhista, formando e capacitando pessoas para que passem a atuar na área de tecnologia.',
                            link: '/educatransforma',
                            textLink: ' Conheça a coleção',
                        },
                    },
                    // {
                    //     symbols: 'ump',
                    //     classObject: { active: false, cultura: true, classPosition: 'ump' },
                    //     objClass: 'cultura',
                    //     content: {
                    //         title: 'Um Pé de Biblioteca',
                    //         description:
                    //             'O Instituto Um Pé de Biblioteca espalha a semente da educação e da leitura por todo o país através da construção de bibliotecas com apoio solidário de empresas. Esse trabalho é feito de voluntários e organizações que a acreditam na educação como ferramenta de transformação.',
                    //     },
                    // },
                ],
                partnerInfos: {
                    title: '',
                    description: '',
                    link: '',
                    textLink: '',
                },
                projSelect: 0,
            };
        },
        created() {
            const izp = (this.partners || []).find((m) => m.symbols === 'izp');
            this.getPartner(izp, false, true);

            const projs = ['izp', 'ama', 'cuf', 'mat', 'tra'];

            setInterval(() => {
                if (this.pauseAnimation === false) {
                    const partner = (this.partners || []).find(
                        (m) => m.symbols === projs[this.projSelect]
                    );
                    this.getPartner(partner);
                    this.projSelect = this.projSelect === 4 ? 0 : this.projSelect + 1;
                }
            }, 2500);
        },
        computed: {
            getPartnerList(name) {
                return this.partners.filter((item) => {
                    return item.objClass.indexOf(name) > -1;
                });
            },
        },
        methods: {
            getPartner(currentPartner, pauseAnimation = false) {
                if (pauseAnimation === true) {
                    this.pauseAnimation = true;
                }

                currentPartner.classObject.active = true;
                this.partners.forEach((partner) => {
                    if (partner.symbols !== currentPartner.symbols) {
                        partner.classObject.active = false;
                    }
                });
                this.partnerInfos.title = currentPartner.content.title;
                this.partnerInfos.description = currentPartner.content.description;
                this.partnerInfos.link = currentPartner.content.link;
                this.partnerInfos.textLink = currentPartner.content.textLink;
            },
        },
    };
</script>

<style></style>
